import { useCallback, useEffect } from 'react';
import { usePathname, useSegments } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export const useRouteObserver = (params: Params) => {
  const { onChange } = params;

  const pathname = usePathname();
  const segments = useSegments();

  const viewKey = segments.join('/');

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleRouteChange = useCallback(() => {
    if (!pathname) return;

    onChange({ pathname, viewKey, segments });
  }, [onChange, pathname, viewKey, segments]);

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(handleRouteChange, [handleRouteChange]);

  // ─────────────────────────────────────────────────────────────────────

  return { pathname, viewKey, segments };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  onChange: (route: RouteInfo) => void;
};

export type RouteInfo = {
  pathname: string;
  viewKey: string;
  segments: string[];
};
